var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04289 6.79289C3.43342 6.40237 4.06658 6.40237 4.45711 6.79289L12.25 14.5858L20.0429 6.79289C20.4334 6.40237 21.0666 6.40237 21.4571 6.79289C21.8476 7.18342 21.8476 7.81658 21.4571 8.20711L12.9571 16.7071C12.5666 17.0976 11.9334 17.0976 11.5429 16.7071L3.04289 8.20711C2.65237 7.81658 2.65237 7.18342 3.04289 6.79289Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.c00dbccc6c0aa671032b12239cd89ee9.svg";
export { ForwardRef as ReactComponent };